import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";

import { SemanticPage } from "../../../workspaces/library/pages/SemanticPage";
import { parseSemanticSearch } from "../../../workspaces/library/pages/semantic-search";

export const Route = createFileRoute("/_console/p/$org/$project/library/search")({
  validateSearch: parseSemanticSearch,
  component: SearchRoute,
});

function SearchRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const onStateChange = useCallback(
    (patch: Partial<typeof search>, options?: { readonly replace?: boolean }) =>
      void navigate({
        search: (current) => ({ ...current, ...patch }),
        replace: options?.replace,
      }),
    [navigate],
  );
  return (
    <SemanticPage state={search} onStateChange={onStateChange} />
  );
}
